import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { loginUser } from "../../actions/authActions";
import classnames from "classnames";
import { support } from "jquery";

class Login extends Component {
  constructor() {
    super();
    this.state = {
      user: "",
      password: "",
      errors: {},
    };
  }

  componentDidMount() {
    if (this.props.auth.isAuthenticated) {
      if (this.props.auth.type == 1) {
        this.props.history.push("/admin-home");
      } else if (this.props.auth.type == 2) {
        this.props.history.push("/patient-list");
      } else if (this.props.auth.type == 3) {
        this.props.history.push("/doctor-home");
      } else if (this.props.auth.type == 4) {
        this.props.history.push("/doctor-home");
      } else if (this.props.auth.type == 8) {
        this.props.history.push("/patient-list");
      } else if (this.props.auth.type == 7) {
        this.props.history.push("/Partner");
      } else if (this.props.auth.type == 9) {
        // Signing Doctor — dedicated review/sign queue
        this.props.history.push("/signing-home");
      }
      // else if (this.props.auth.type == 8){
      //   this.props.history.push("support-home")
      // }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.auth.isAuthenticated) {
      if (nextProps.auth.type == 1) {
        this.props.history.push("/admin-home");
      } else if (nextProps.auth.type == 2) {
        this.props.history.push("/patient-list");
      } else if (nextProps.auth.type == 3) {
        this.props.history.push("/doctor-home");
      } else if (nextProps.auth.type == 4) {
        this.props.history.push("/support-home");
      } else if (nextProps.auth.type == 8) {
        this.props.history.push("/patient-list");
      } else if (nextProps.auth.type == 7) {
        this.props.history.push("/Partner");
      } else if (nextProps.auth.type == 9) {
        // Signing Doctor — dedicated review/sign queue
        this.props.history.push("/signing-home");
      }
      // else if (nextProps.auth.type == 8) {
      //   this.props.history.push("support-home");
      // }
    }
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
  }

  onChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = (e) => {
    e.preventDefault();

    const userData = {
      user: this.state.user,
      password: this.state.password,
    };
    this.props.loginUser(userData);
  };

  render() {
    const { errors } = this.state;

    const inputStyle = {
      width: "100%", height: 44, padding: "0 14px",
      background: "#0f3538", border: "1px solid rgba(46,170,187,0.3)",
      borderRadius: 8, color: "#e2eef2", fontSize: 14, outline: "none",
      transition: "border-color 0.2s, box-shadow 0.2s",
    };
    const labelStyle = {
      color: "#89a8c0", fontSize: 11, fontWeight: 600,
      textTransform: "uppercase", letterSpacing: "0.5px",
      marginBottom: 6, display: "block",
    };

    return (
      <div style={{
        minHeight: "100vh", width: "100%",
        background:
          "radial-gradient(circle at 50% 35%, rgba(46,170,187,0.12) 0%, rgba(0,0,0,0) 60%), " +
          "linear-gradient(180deg, #041415 0%, #072224 70%, #041415 100%)",
        display: "flex", flexDirection: "column",
      }}>
        {/* Header */}
        <header style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "14px 28px",
          background: "rgba(7,34,36,0.7)",
          borderBottom: "1px solid rgba(46,170,187,0.18)",
          backdropFilter: "blur(6px)",
        }}>
          <a href="/" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none" }}>
            <img src="dist/img/logo.png" alt="brand" style={{ height: 30 }} />
            <span style={{ color: "#e2eef2", fontWeight: 700, fontSize: 17, letterSpacing: "0.4px" }}>
              Biocalculus
            </span>
          </a>
          <div style={{ display: "flex", gap: 10 }}>
            <a href="/user-login" style={{
              padding: "8px 16px", fontSize: 12, fontWeight: 600,
              background: "transparent", border: "1px solid #2eaabb",
              borderRadius: 20, color: "#2eaabb", textDecoration: "none",
              transition: "all 0.15s",
            }}>Are you a user?</a>
            <a href="/signup" style={{
              padding: "8px 16px", fontSize: 12, fontWeight: 600,
              background: "linear-gradient(90deg,#1e8449,#27ae60)", border: "none",
              borderRadius: 20, color: "#fff", textDecoration: "none",
              boxShadow: "0 3px 10px rgba(39,174,96,0.25)",
            }}>Sign Up</a>
          </div>
        </header>

        {/* Card */}
        <div style={{
          flex: 1, display: "flex",
          alignItems: "center", justifyContent: "center",
          padding: "40px 16px",
        }}>
          <div style={{
            width: "100%", maxWidth: 440,
            borderRadius: 16, overflow: "hidden",
            background: "linear-gradient(160deg,#0e2a2e 0%,#0a1f22 100%)",
            boxShadow: "0 24px 60px rgba(0,0,0,0.6), 0 0 0 1px rgba(46,170,187,0.18)",
          }}>
            {/* Card header */}
            <div style={{
              background: "linear-gradient(90deg,#0c2e32 0%,#0f3538 100%)",
              padding: "22px 26px",
              borderBottom: "1px solid rgba(46,170,187,0.18)",
              textAlign: "center",
            }}>
              <div style={{
                width: 56, height: 56, borderRadius: 14, margin: "0 auto 12px",
                background: "linear-gradient(135deg,rgba(46,170,187,0.3),rgba(46,170,187,0.08))",
                border: "1px solid rgba(46,170,187,0.4)",
                display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24,
              }}>🩺</div>
              <div style={{ color: "#e2eef2", fontWeight: 700, fontSize: 18 }}>Sign in as Doctor</div>
              <div style={{ color: "#4a8a9a", fontSize: 12, marginTop: 4 }}>
                Enter your details below
              </div>
            </div>

            {/* Card body */}
            <form method="post" onSubmit={this.onSubmit} style={{ padding: "24px 26px", background: "#0a1f22" }}>

              {/* Error banner */}
              {errors.result && (
                <div style={{
                  marginBottom: 16, padding: "10px 14px",
                  borderRadius: 8,
                  background: "rgba(231,76,60,0.12)",
                  border: "1px solid rgba(231,76,60,0.4)",
                  color: "#ff6b6b",
                  fontSize: 12, fontWeight: 500,
                  display: "flex", alignItems: "center", gap: 8,
                }}>
                  <span>⚠️</span><span>{errors.result}</span>
                </div>
              )}

              {/* Email / Phone */}
              <label style={labelStyle}>📧 Email Address / Phone Number</label>
              <input
                type="text"
                name="user"
                required=""
                id="user"
                onChange={this.onChange}
                value={this.state.user}
                placeholder="you@example.com  or  9999999999"
                style={{ ...inputStyle, marginBottom: 18 }}
              />

              {/* Password label + forgot link */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                <label style={labelStyle}>🔑 Password</label>
                <a href="/user/forgot-password"
                  style={{ color: "#2eaabb", fontSize: 11, textDecoration: "none", fontWeight: 600 }}
                >Forgot password?</a>
              </div>
              <input
                type="password"
                name="password"
                data-minlength="6"
                required=""
                id="password"
                placeholder="Enter password"
                onChange={this.onChange}
                value={this.state.password}
                style={{ ...inputStyle, marginBottom: 16 }}
              />

              {/* Keep me logged in */}
              <label style={{ display: "flex", alignItems: "center", gap: 8, color: "#9ab3bd", fontSize: 12, marginBottom: 22, cursor: "pointer" }}>
                <input id="checkbox_2" type="checkbox" style={{ width: 14, height: 14, accentColor: "#2eaabb", cursor: "pointer" }} />
                Keep me logged in
              </label>

              {/* Submit */}
              <button
                type="submit"
                style={{
                  width: "100%", height: 46, fontSize: 14, fontWeight: 700,
                  background: "linear-gradient(90deg,#1e8449,#27ae60)",
                  border: "none", borderRadius: 10,
                  color: "#fff", cursor: "pointer",
                  letterSpacing: "0.6px", textTransform: "uppercase",
                  boxShadow: "0 6px 18px rgba(39,174,96,0.35)",
                  transition: "transform 0.1s, box-shadow 0.2s",
                }}
              >
                🔐 Sign In
              </button>
            </form>

            {/* Footer link */}
            <div style={{ textAlign: "center", padding: "12px", background: "#0c2e32", borderTop: "1px solid rgba(46,170,187,0.18)" }}>
              <span style={{ color: "#5a8fa8", fontSize: 12 }}>New here? </span>
              <a href="/signup" style={{ color: "#2eaabb", fontSize: 12, fontWeight: 600, textDecoration: "none" }}>Create an account</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  loginUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, { loginUser })(withRouter(Login));
